import apiClient from 'api/apiClient';

export const getFeatureFlags = () => apiClient.get('/v1/feature_flags');

export default getFeatureFlags;
